export default __webpack_public_path__ + "static/media/unauthorized.68910cd7.svg";